import React from "react";
import people from "../../assets/people.png";
import ai from "../../assets/ai.png";
import "./header.css";

const Header = () => {
	return (
		<div className="gpt__header section__padding" id="home">
			<div className="gpt__header-content">
				<h1 className="gradient__text">
					Let's Build Something Amazing with GPT-3 Open AI
				</h1>
				<p>
					Yet bed any for travelling assistance indulgence unpleasing. Not
					thoughts all exercise blessing. Indulgence way everything joy
					alteration boisterous the attachment. Party we years to order allow
					asked of.
				</p>

				<div className="gpt__header-content__input">
					<input type="email" placeholder="Your Email Address" />
					<button className="gpt__header-content__input__button">
						Get Started
					</button>
				</div>

				<div className="gpt__header-content__people">
					<img src={people} alt="people" />
					<p>1,600 people requested access a visit in last 24 hours</p>
				</div>
			</div>
			<div className="gpt__header-img">
				<img src={ai} alt="AI" />
			</div>
		</div>
	);
};

export default Header;
